const _version = "3.2.5"
function version() {
    return _version
}
export default version
